export const MATCH_RATE_BUCKET = ['<50%', '60%-50%', '70%-60%', '80%-70%', '90%-80%', '>90%'];
